import SearchRequests from './components/searchRequests/searchRequests.vue'
import TableRequests from './components/tableRequests/tableRequests.vue'
import RequestDetails from './components/requestDetails/requestDetails.vue'
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
export default {
  name: 'requests',
  mixins: [ PermisionMixin ],
  components: {
    SearchRequests,
    TableRequests,
    RequestDetails,
    RequestsRepository
  },
  data () {
    return {
      requestsDetails: false,
      selectedSolicitacao: {},
      tablereload: 0,
      roles: Roles
    }
  },
  methods: {
    edit (obj) {
      this.selectedSolicitacao = obj
      this.requestsDetails = true
    },
    GetFilter (filter, isFilter) {
      this.$refs.tableRequestComponent.searchWithFilter(filter, isFilter)
    },
    updateTable () {
      this.tablereload++
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/requests.js